import { NavLink } from "react-router-dom"
import Icon from "@material-tailwind/react/Icon"
import { RadioGroup } from "@mantine/core"

const SidebarItem = ({ route, iconName, text, setShowSidebar }) => {
  const LARGE_DEVICE_WIDTH = 1024

  const toggleSidebar = () => {
    if (window.innerWidth <= LARGE_DEVICE_WIDTH) {
      setShowSidebar("-left-64")
    }

    localStorage.setItem("path", route)
  }

  return (
    <li className='rounded-lg mb-4'>
      <NavLink
        to={route}
        exact='true'
        className='flex items-center gap-4 text-sm text-white font-bold px-4 py-3 rounded-lg'
        activeclassname='bg-gradient-to-tr from-light-blue-500 to-light-blue-700 shadow-md'
        onClick={toggleSidebar}>
        <Icon name={iconName} size='2xl' />
        {text}
        {}
      </NavLink>
    </li>
  )
}

export default SidebarItem
